import {writable} from "svelte/store";

export interface FormAttributes {
    nonce: string;
    rest_url: string;
    result: {
        success_title: string;
        success_content: string;

        error_title: string;
        error_content: string;
    }
    data: FormAttributesData;
}

export interface FormAttributesData {
    categories: Categories
    main_qualifications: string[]
    psych_methods: string[]
}

export interface Categories {
    "CAT 1 (Ontwikkelvraagstuk)": string[]
    "CAT 2 (Specifieke klachten)": string[]
    "CAT 3 (Specialistische begeleiding)": string[]
    "CAT 4 (Overbrugging)": string[]
}

export const FormAttributesStore = writable<FormAttributes>();
